import '../css/HeroCSS.css';
import logo from "../assets/WithShapes2.webp";


import b1 from "../assets/back1_1.png";
import b2 from "../assets/back1_2.png";
import { useEffect } from 'react';

// import logo3 from "../assets/MybNeGarbageFade.png";
// import logo2 from "../assets/rend1.png";

const Hero1 = () => {


  useEffect(() => {
  const el = document.querySelector('.fadeThenBob');
  const observer = new IntersectionObserver(
    ([entry], observer) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    },
    { threshold: 0.2 }
  );
  if (el) observer.observe(el);
  return () => observer.disconnect();
}, []);



  return (
    <div id='home' className='hero'>
      <div className='heroContent'>
        <img className='fadeThenBob' src={logo} alt="logo" style={{ height: "300px" }} />
        <div className='fadeOnScroll'>
          <h1 data-translate="hero1" style={{ color: "white", fontSize: "50px" }}>Simple Fun for Everyone!</h1>
          <p data-translate="hero2" style={{ color: "white", fontSize: "20px" }}>Casual Games & Gamified Apps</p>
          <br />
        </div>
      </div>
      {/* <div>
        <img src={logo2} alt="logo" style={{height:"400px", width:"100%"}} />
      </div> */}
    </div>
  )
}

export default Hero1